import { useState } from 'react';

//components
import AddPrompt from './components/AddPrompt';
import PromptList from './components/PromptList';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const Prompt = () => {
  const [showForm, setShowForm] = useState(false);
  const [reloadList, setReloadList] = useState(false);

  const handlePromptCreated = () => {
    setReloadList((prevState) => !prevState);
    setShowForm(false);
  };

  return (
    <div className="projects-container">
      <h1>Gestione Prompt</h1>
      <div className="prompt__Wrapper">
        <PromptList reloadList={reloadList} />
        <Button
          onClick={() => setShowForm(!showForm)}
          style={{ marginBottom: '2rem' }}
        >
          Crea nuovo Prompt
        </Button>
        <Dialog
          header="Crea nuovo Prompt"
          visible={showForm}
          style={{ width: '50vw' }}
          modal
          onHide={() => setShowForm(false)}
        >
          <AddPrompt onPromptCreated={handlePromptCreated} />
        </Dialog>
      </div>
    </div>
  );
};

export default Prompt;
